import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';

import { AppComponent } from '../../app.component';

import { TopnavComponent } from '../../topnav/topnav.component';
import { SidemenuComponent } from '../../sidemenu/sidemenu.component';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../appSettings';
import { LoginService } from '../../services/login.service';
import { CommonService } from '../../services/common.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';

declare var jquery:any;
declare var $ :any;
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-addarticle',
  templateUrl: './addarticle.component.html'
})
export class AddarticleComponent implements OnInit, AfterViewInit, OnDestroy {

  currentUser:any;
  currentUserID:any;
  currentUsername:any;
  currentUsergroup:any;
  currentUserStatus:any;
  currentAllUsers:any;
  select: any;
  getarticlecategorylistbyuserid:string = AppSettings.getarticlecategorylistbyuserid;
  uploaduserProfileApi:string=AppSettings.uploadcropimage;
  insertarticleRestApiUrl :string = AppSettings.addarticle;
  categorylist:Array<Object>;
  model: any = {};
  model1: any = {};
  alldata: any = {};
  localdata:any={};
  imageChangedEvent: any = '';
  croppedImage: any = '';
  statusOptions: any[] = [
    { value: 'published', label: 'Published' },
    { value: 'draft', label: 'Draft' }
  ];

  @ViewChild('contentEditor') contentEditor!: ElementRef;

  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http) {
      document.body.className="theme-red";
  }

  ngOnInit() {
     this.loginService.localStorageData();
      this.loginService.viewsActivate();
      /*category list*/

      let user_id = localStorage.getItem('currentUserID');
      let currentUser =localStorage.getItem('currentUser');
     this.localdata.imagePath = AppSettings.API_BASE;
    this.localdata.usergroup=localStorage.getItem('currentUsergroup');

    // Load article categories
    this.CommonService.getdata(this.getarticlecategorylistbyuserid + user_id)
    .subscribe(resultdata =>{
        if(resultdata.result!="")
        {
          this.categorylist=resultdata.result;
        }
    });

    // Initialize article model
    this.model.status = 'draft'; // Default status
    this.model.user_id = user_id;
    this.model.author = currentUser; // Author is the user_id
  }

  addarticle()
  {
    // If there's an image to upload, upload it first
    if(this.model1.Imagefile) {
      this.CommonService.insertdata(this.uploaduserProfileApi,this.model1)
      .subscribe( (response) => {
         if(response.status=='success')
         {
          this.model.image = response.data;
          this.submitArticle();
         }
          else{
            swal('',"Error while uploading photo",'Oops!');
          }
       })
    } else {
      this.submitArticle();
    }
  }

  submitArticle() {
    // Get content from custom editor
    if (this.contentEditor) {
      this.model.content = this.contentEditor.nativeElement.innerHTML;
    }

    this.CommonService.insertdata(this.insertarticleRestApiUrl,this.model)
    .subscribe(package_det =>{
         swal(
          package_det.status,
          package_det.message,
          package_det.status
        )
        if(package_det.status == 'success') {
          this.router.navigate(['/managearticles']);
        }
    });
  }

  // Rich text editor methods
  formatText(command: string, value?: string) {
    document.execCommand(command, false, value);
    if (this.contentEditor) {
      this.model.content = this.contentEditor.nativeElement.innerHTML;
    }
  }

  insertLink() {
    const url = prompt('Enter URL:');
    if (url) {
      document.execCommand('createLink', false, url);
      if (this.contentEditor) {
        this.model.content = this.contentEditor.nativeElement.innerHTML;
      }
    }
  }

  onContentChange() {
    if (this.contentEditor) {
      this.model.content = this.contentEditor.nativeElement.innerHTML;
    }
  }
  fileEvent($event) {
    const fileSelected: File = $event.target.files[0];

    this.CommonService.uploadFile(this.uploaduserProfileApi,fileSelected)
    .subscribe( (response) => {
       if(response.status=='success')
       {
        this.model.image = response.data;
       }
        else{
          swal('',"Error while on upload photo",'Oops!');
        }
     })
   }
  logout(){
    this.loginService.logout();
  }

    back(){
    this.router.navigate(['/managearticles']);
  }

    ngAfterViewInit() {
      // Initialize content editor
      setTimeout(() => {
        if (this.contentEditor && this.model.content) {
          this.contentEditor.nativeElement.innerHTML = this.model.content;
        }
      }, 100);
    }

    ngOnDestroy() {
      // No cleanup needed for custom editor
    }
 
  
   fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }
  imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.model1.Imagefile = event.base64;
    }

}
